import { Activity, AlertTriangle, CheckCircle, Gauge, Timer, XCircle } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { DrillDownKpi } from '../../../utils/drillDownKpis';
import { DashboardMetricCard } from '../DashboardMetricCard';
import { ColumnHeaderHelp } from '../../shared/ColumnHeaderHelp';

const KPI_ICONS: Record<string, LucideIcon> = {
  count: CheckCircle,
  avgDuration: Timer,
  avgQuality: Gauge,
  ndtCoverage: Activity,
  ndtTotalLogs: Activity,
  ndtWeldsWithRecords: Activity,
  ndtRejected: XCircle,
  passBreaches: AlertTriangle,
  topFailedParam: AlertTriangle,
  topDefect: AlertTriangle,
  within: CheckCircle,
  out: XCircle,
  rate: Gauge,
  ndtRejectRate: XCircle,
};

interface DrillDownKpiStripProps {
  kpis: DrillDownKpi[];
}

export const DrillDownKpiStrip = ({ kpis }: DrillDownKpiStripProps) => (
  <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-5">
    {kpis.map((kpi) => (
      <DashboardMetricCard
        key={kpi.id}
        label={
          kpi.help ? (
            <ColumnHeaderHelp label={kpi.label} help={kpi.help} />
          ) : (
            kpi.label
          )
        }
        value={kpi.value}
        icon={KPI_ICONS[kpi.id] ?? Gauge}
        accent={kpi.accent ?? 'blue'}
      />
    ))}
  </div>
);
